import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';

import { ScheduledCallsForm } from '../components/ScheduledCallsForm/ScheduledCallsForm';
import {
  IScheduledCallCreatePopupProps,
  useScheduledCallCreatePopupPresenter,
} from './ScheduledCallCreatePopup.presenter';

export const ScheduledCallCreatePopup: FC<ICommonPopupsProps<IScheduledCallCreatePopupProps>> =
  observer((props) => {
    const { t } = useTranslation();
    const presenter = useScheduledCallCreatePopupPresenter(props);

    return (
      <Popup
        title={t('call_scheduled_call')}
        isOpened
        handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
        onClose={presenter.onClose}
      >
        <ScheduledCallsForm
          onSubmit={presenter.onSubmit}
          initialValues={presenter.initialValues}
        />
      </Popup>
    );
  });
